export const formatTransferDate = (date?: Date): string => {
    return date
        ? date.getMonth() + 1 + "-" + date.getDate() + "-" + date.getFullYear()
        : "";
};
